/**
 * The cancellation reasons, in one place.
 *
 * They were duplicated four times: CancelReasonSelect(.Bulk) for sales and
 * CancelDesignReasonSelect(.Bulk) for design. Since EH-1840 the sales list is
 * also an integration contract: when a sales task is cancelled, the actions
 * service moves the matching HubSpot deal to Verloren and translates the label
 * below into the internal `verliesreden` value in
 * `backend/src/actions_service/hubspot/reasons.py`.
 *
 * If you add a reason here, add it there too. If you don't, the deal does get
 * the right stage but no reason, and the worker logs an error. The actions
 * service test suite checks that every reason in this list is covered.
 */

export const SALES_CANCELLATION_REASONS: string[] = [
  'Verbruik te laag',
  'Niet bereikbaar',
  'Contactgegevens onjuist',
  'Geen vertrouwen',
  'Andere reden',
  'Taalbarriere',
  'Bezwaar tegen woco',
  'Leeftijd (te oud)',
  'Vindt besparing te laag/Prijs te hoog',
  'Gaat binnenkort verhuizen',
  'Geen interesse',
  'Deadline verlopen',
  'Complex niet naar uitvoering',
  'Opt out',
  'Snapt het niet',
  'Design is geannuleerd',
  // These two already existed as `verliesreden` in HubSpot but not in ERP.
  // Without them werving could pick a reason there that did not exist here, and
  // it was silently lost in the one-way sync.
  'Wil geen werkzaamheden in huis',
  'Geen reactie meer',
]

/**
 * Design kent zijn eigen redenen; die gaan niet naar HubSpot, want een
 * design-annulering is geen wervingsuitkomst. Wel neemt de cascade de sales task
 * mee met de reden 'Design is geannuleerd', en díe komt wel in HubSpot terecht.
 */
export const DESIGN_CANCELLATION_REASONS: string[] = [
  'Minimale opwek niet gehaald',
  'Minimaal aantal panelen past niet',
  'Liggen al panelen op het dak',
  'Individueel past niet, design voor CVZ installatie',
  'Sedumdak',
  'Betreden dak onmogelijk',
  'Afvallen op aanvraag WoCo',
  'Asbest geconstateerd/losse EPS-korrels',
  'Andere reden',
]
